import { parseEmoji } from '@/lib/discordEmoji'

/**
 * One stored emoji, whichever kind it is: a guild emoji as its image, a plain
 * unicode emoji as text. Everywhere a sign-up position's icon is drawn goes
 * through here, so the two kinds never need telling apart at the call site.
 */
export default function EmojiGlyph({ emoji, size = 16, className = '', title }: {
  emoji?: string | null
  size?: number
  className?: string
  /** İpucu. Verilmezse özel emoji kendi adını söyler (`assault`). */
  title?: string
}) {
  const parsed = parseEmoji(emoji)
  if (!parsed) return null
  if (parsed.kind === 'custom') {
    return (
      <img
        src={parsed.url}
        alt={parsed.name}
        title={title ?? parsed.name}
        width={size}
        height={size}
        className={`inline-block shrink-0 object-contain ${className}`}
        style={{ width: size, height: size, maxWidth: 'none' }}
      />
    )
  }
  return (
    <span
      title={title}
      className={`inline-block shrink-0 leading-none ${className}`}
      style={{ fontSize: size }}
    >
      {parsed.char}
    </span>
  )
}
